// oxlint-disable sorare/no-unused-fragment-fields
import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Notification_notificationInterface } from './__generated__/fragments.graphql.ts';

export const commonNotificationInterfaceFragment = gql`
  fragment Notification_notificationInterface on NotificationInterface {
    id
    name
    createdAt
    sport
    read
    title
    markdownBody
  }
` as TypedDocumentNode<Notification_notificationInterface>;
